module.exports = __webpack_public_path__ + "img/home_btn.d04ed84a.png";